import { render } from "./i-checkbox.vue?vue&type=template&id=4b6047f7"
import script from "./i-checkbox.vue?vue&type=script&lang=js"
export * from "./i-checkbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__